import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const TheetuPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `

<h1>தீட்டு விஷயங்கள்</h1>
<div class="div4">
  
<div class="head2">
  <b>தீட்டு சிறு விளக்கம்</b>
</div>




<span style="color: red">
  <strong>ஜனனம் மற்றும் மரணத்தினால் ஏற்படும் தீட்டு விளக்கங்கள்</strong>
</span>
<hr> ஒரு ஆணுக்கு பிறக்கும் ஆண் குழந்தைகள், அந்த ஆண் குழந்தைகளுக்குப் பிறக்கும் ஆண் குழந்தைகள் என வரிசையாக வரும் சந்ததியில்
ஏற்படும் அனைத்துக் கிளைகளிலும் உள்ள ஆண்கள் அனைவரும் பங்காளிகள் எனப்படுவர். மூல புருஷன் எனப்படும் ஒரு ஆண் வழியாக தோன்றும்
மகன்-பேரன்-கொள்ளுப்பேரன்-எள்ளுப்பேரன் எள்ளுப்பேரனுக்கு மகன் - எள்ளுப்பேரனுக்குப் பேரன் வரையில் மூல புருஷனையும் சேர்த்து
7 தலைமுறைகள் ஆகின்றது. இதற்குள் அடங்கும் அத்தனை பங்காளிகளில் யாராவது ஒருவர் இல்லத்தில் ஏற்படும் பிறப்பினாலும் (ஜனனத்தாலும்)
அல்லது இறப்பினாலும் (மரணத்தாலும்) அனைவருக்கும் தீட்டு உண்டாகும்.
<hr>
<ol class="myol">
  <li>
    <strong>
      <span style="color: firebrick">தீட்டுக் காலத்திலும் கண்டிப்பாக சந்தியாவந்தனம் பண்ணவேண்டும். 
        ப்ராணாயாமம் மந்திரமின்றிப் பண்ணவேண்டும். ருஷி, சந்தஸ் கிடையாது. காயத்திரி எண்ணிக்கை மட்டும் 10 காயத்திரியுடன் நிறுத்திக்
        கொள்ளவேண்டும்.</span>
    </strong>
  </li>
  <li>மற்ற காம்யமான ஜபங்கள் கிடையாது.
    <strong>
      <span style="color: firebrick"></span>
    </strong>
  </li>
</ol>
தாய் வழியாகவும் சில தீட்டுகள் ஏற்படும். தீட்டு பற்றிய விஷயங்களுக்கு மூல ஆதாரம் "வைத்யநாத தீக்ஷிதீயம் ஆசெளச காண்டம்" ஆகும்.

<div class="head2">
  <b>தீட்டு என்றால் என்ன?</b>
</div>
இங்கு மிகவும் சுலபமான முறையில் தீட்டு விஷயங்கள் விளக்கப் படுகிறது. மிகவும் நுணுக்கமான விஷயங்களை அறிய ஒரு நாள் அவகாசத்துடன்
ஈமெயில் மூலம் தெரிந்து கொள்ளலாம்.
<hr>
<hr>
<span style="color: crimson">தீட்டு என்றால் என்ன? என்று கூட சிலர் கேட்கிறார்கள்.&nbsp;
  <hr> தீட்டுக் காரியங்கள் நடக்கும் இடத்தின் மற்றும் பொருடக்களின் சம்மந்தம் ஆன்மீகம் மற்றும் விஜ்ஞான ரீதியாகவும் விலக்கத்
  தக்கது என்பது கருத்து. ஆன்மீகம்
  <span style="color: darkblue">
    தீட்டு</span> என்று சொல்லி விலகி நிற்கச் சொல்கிறது. விஜ்ஞானம்
  <span style="color: green">
    ஹைஜீனிக்</span> என்று சொல்லி விலகி நிற்கச் சொல்கிறது.
  <hr>
  <hr> எனவே ஆன்மீக ரீதியாக யார் யார் எவ்வளவு நாட்கள் பிறரிடமிருந்தும், வழக்கமான மேம்பாட்டு வழிமுறைகள் நெறிமுறைகளிலிருந்தும்
  சில காரணங்களை உத்தேசித்து &nbsp;விலகி நிற்கச் சொல்கிறது. &nbsp;
  <hr> உறவைக் கொண்டு அவர்களின் விலகி நிற்கவேண்டிய கால அளவை வெகு அழகாக நிச்சயித்துள்ளார்கள்.</span>
<hr>
<span style="color:Blue">உறவு உள்ள அளவிற்கு எங்களுக்கு நெருக்கமில்லை நாங்கள் ஏன் அதைக் கடைப்பிடிக்க வேண்டும்? என்று சிலர் கேட்கிறார்கள்.
  <hr> சென்னை போன்ற பெரு நகரங்களில் கார் செல்லும் வழி, மோட்டார் சைக்கிள் செல்லும் வழி, பஸ் செல்லும் வழி, கனரக வாகனங்கள் செல்லும்
  வழி, நடந்து செல்லும் வழி என பாதையைப் பகுத்து வைத்து இந்தந்த பாதையில் செல்வோர் இன்னின்ன வேகத்தில் செல்ல வேண்டும் என்று
  நிர்ணயம் செய்துள்ளார்கள். காரில் செல்பவன் தனக்குள்ள பாதையை விடுத்து மற்ற பாதையில் சென்று கொண்டு நான் நடந்து செல்லவில்லையாதலால்
  எனக்கு அந்தவிதி பொருந்தாது என்று கூறி அவனுடைய வேகத்திற்குச் செல்லமுடியாது.
  <hr> அதுபோல, இந்த உறவு இருப்பவர்களுக்கு இந்த அளவு நெருக்கம் இருக்கும் இருக்கவேண்டும் என்பது பொது விதி. அப்படி நெருக்கம்
  இல்லாதது விதிசெய்தவன் குற்றமல்ல. இதுபோன்ற விதிவிலக்குகளுக்காக வேண்டி விதியை மாற்றி அமைக்க முடியாது. எனவே (உறவு முறையில்)
  நெருக்கம் இருந்தாலும் இல்லாவிட்டாலும்&nbsp; உறவுமுறையுடன் பிறந்து தொலைத்த காரணம் கருதி விதிப்படி அநுட்டிப்பதே விவேகமாகும்.
  </span>
<hr>
<div class="head2">
  <b>தீட்டில் நியமங்கள்</b>
</div>

<ol class="myol">
  <li>தீட்டுள்ளவன் வீட்டில் தீட்டற்றவன் தெரிந்து சாப்பிட்டால் அன்றையபொழுது அவனுக்குத் தீட்டு.
  </li>
  <li>தீட்டுப்போகும் தினத்தில் சுமார் காலை எட்டரை மணிக்கு (ஸங்கவ காலம்) மேல்தான் தீர்த்தமாடி தீட்டை முடிக்க வேண்டும்.</li>
  <li>பிறப்பு, இறப்பு, மாதவிடாய் (தூரம்) இவை சூர்ய உதயத்திற்கு பதினொன்றேகால் நாழிகை(270 நிமிடங்கள்)க்கு முன் ஏற்பட்டால் முதல்
    நாள் கணக்கு. அதன் பிறகானால் மறுநாள் கணக்கு.</li>
  <li>ப்ரேதத்தின் பின் போனாலும் க்ஷவரம் செய்து கொண்டாலும் இரு முறை ஸ்நானம் செய்ய் வேண்டும்.</li>
  <li>ஸந்யாசிகளுக்கு (முன் ஆச்ரம) மாதா, பிதாக்களின் மரணத்தில் மட்டும் ஸ்நாநம்.</li>
  <li>88 அடிகளுக்குள் பிணம் (சவம்) இருந்தால், எடுக்கும்வரை, சமைப்பது, சாப்பிடுவது கூடாது.</li>
  <li>ஸந்யாசியின் சவமானால் அந்தப் பகுதிக்கே தீட்டுக் கிடையாது.</li>
  <li>நகரங்களுக்கு மேற்படி தோஷங்கள் எதுவுமில்லை.</li>
  <li>ஸ்நானம் பண்ணமுடியாத அளவிற்கு நோயுள்ள தீட்டுகாரனின் தீட்டுப்போக வேண்டுமானால், தீட்டற்ற ஒருவன் தீட்டுள்ளவனைத் தொட்டுவிட்டு
    தீர்த்தமாடி பின் தொட்டு தீர்த்தமாடி என பத்து முறை தீர்த்மாடவேண்டும். </li>
  <li>அதுபோல் நோயுள்ள தூர ஸ்த்ரீயை மற்றொருத்தி 12 முறை தொட்டு தீர்த்தமாடி வேறு உடை உடுத்தச் செய்தால் சுத்தி. இரண்டிலும்
    புண்யாஹவாசனம் முக்கியம்.</li>
</ol>
<hr>
<ol class="myol">
  <li>தீட்டின் இடையில் ச்ராத்தம் வந்தால், திதி, கிழமை, நக்ஷத்திரம் போன்ற எதையும் பாராமல் தீட்டு முடிந்த மறுதினம் ச்ராத்தம்
    பண்ணவேண்டும்</li>
  <li>ச்ராத்தத்தின் நடுவில் (ச்ராத்த சங்கல்பம் ஆனபின்) தீட்டுத் தெரிந்தால் ச்ராத்தம் முடியும்வரை கர்த்தாவுக்குத் தீட்டில்லை.</li>
  <li>வரித்தபின் போக்தா (ச்ராத்த ஸ்வாமி)க்கு தீட்டுத் தெரிந்தால் சாப்பிட்டு முடியும்வரை தீட்டில்லை.
  </li>
  <li>விவாஹத்தில் உத்வாஹ சங்கல்பத்தின் பின் தீட்டுத் தெரிந்தால் சேஷ ஹோமம் வரை தீட்டில்லை.</li>
  <li>ஸந்யாசிகளின் மரணத்தினால் அவரின் பங்காளிகளக்குத் தீட்டில்லை, அவப்ருத ஸ்நாநம் மட்டும்.</li>
</ol>
<span style="color: #dc143c">மற்ற சில கவனிக்கத் தக்கவை</span>
  <hr>
 <ol class="myol">
    <li>ராஜாங்கத்தால் கொலை தண்டனை விதிக்கப்பட்டவனுக்கு உடனே கர்மா செய்யலாம்.</li>
    <li>துர் மரணம் செய்து கொண்டவனுக்கு 6 மாதம் கழித்து கர்மா செய்ய வேண்டும் என்பது விதி ஆயினும் 24 நாட்கள் கழித்து செய்வது
      என்றும் ஒரு விதி உள்ளது.</li>
    <li>தற்செயலாய் துர்மரணம் அடைவோருக்கு தீட்டு, தர்பணம் முதலியவை உண்டு.</li>
    <li>தற்கொலை செய்துகொண்டவனுக்கு தீட்டு, தர்பணம் இவை இல்லை.</li>
    <li>கர்மா செய்பவனுக்கு 11ம் நாள் கர்மாவிற்குப் பின் தீட்டுப் போகும்.</li>
    <li>கல்யாணமான பெண் இறந்தால் அவள் பிறந்த வீட்டுப் பங்காளிகளுக்கு தீட்டில்லை.</li>
    <li>பிறப்புத் தீட்டுள்ளவனை 4 நாளைக்கு மேல் தீண்டினால் அதிகம் தோஷமில்லை.</li>
    <li>ஒரு தீட்டுக் காரன் மற்றொரு தீட்டுக்காரனைத் தொடக் கூடாது.</li>
    <li>தீட்டுள்ளவன் வீட்டுக்கும் அவன் சாமான்களுக்கும் தீட்டுண்டு.</li>
    <li>பிரம்மச்சாரிகள் கர்மா செய்தால் அதனுடன் தர்பணம் (உதகதானம்) தனியாக இல்லை.</li>
    <li>மனைவி கர்பமாக இருக்கும்போது தானம் வாங்குதல், தூரதேச யாத்திரை போதல் கூடாது.</li>
    <li>சவத்துக்கு முன்னாலும், பக்கவாட்டிலும் போகக் கூடாது.</li>
    <li>சஞ்சயனம் ஆனபின் துக்கம் விசாரித்தால் ஆசமனம் மட்டும் போதும்.</li>
    <li>சிராத்த தினத்தன்று துக்கம் விசாரிக்கச் செல்லக் கூடாது.</li>
    <li>தன் மனைவி கர்பமாய் இருக்கும்போது தாய், தந்தை தவிர மற்றவர்களின் சவத்தை சுமக்கலாகாது.</li>
    <li>ப்ரம்மச்சாரிகள் தாய் தந்தை சவத்தைத் தவிர மற்வர்கள் சவத்தைச் சுமக்கக்கூடாது.</li>
    <li>தீட்டுக் காரர்கள் ஆலயத்திற்குள் செல்லக் கூடாது.</li>
    <li>தீட்டுக்காரர்களை தீட்டில்லாதவர்கள் நமஸ்கரிக்கக் கூடாது. தீட்டுக்காரரும் அப்படியே.</li>
    <li>ஜனன, மரண தீட்டிலும் ஏகாதசி, துவாதசி விரதம் விடக் கூடாது. உபவாஸம் மட்டும், பூஜை கிடையாது.</li>
    <li>சாவு தீட்டுக்காரர் மெத்தை போன்றவற்றில் படுக்கக் கூடாது. தினமும் தீர்த்தமாடவேண்டும்.</li>
    <li>சிசுக்கள் இறந்தால் புதைத்த தினம் முதல்தான் தீட்டு</li>
  </ol>
   <div class="head2">
    <b>தீட்டில் வேறு தீட்டு சோ்ந்தால்?</b>
  </div>

  <ol class="myol">
    <li>பங்காளிகளைப் பொறுத்தவரையில் ஒரு தீட்டு காத்துக் கொண்டிருக்கும்போது மற்றொரு தீட்டு வந்தால் முன் வந்த தீட்டு முடியும்போது
      பின் வந்த தீட்டும் முடிந்துவிடும். </li>
    <li>உதாரணமாக 10நாள் தீட்டில் 4ம் நாள் மற்றொரு 10 நாள் தீட்டு வந்தால் முன் வந்த தீட்டின் 10ம் நாளுடன் பின் வந்த தீட்டும்
      முடிந்துவிடும்.</li>
    <li>ஆனால் முன் வந்த 3 நாள் தீட்டுடன் பின் வந்த 10 நாள் தீட்டு முடியாது. </li>
    <li>பத்துநாள் தீட்டின் இடையில் வந்த 3 நாள் தீட்டுடன் 10 நாள் தீட்டு முடியாது. 10ம் நாள்தான் சுத்தி.
    </li>
    <li>பத்தாம் நாள் இரவில் வந்த புதிய பத்து நாள் தீட்டிற்கு அதிகப்படியாக 3நாள் மட்டும் காத்தால் போதும்.</li>
    <li>ஆனால் பிறப்புத் தீட்டின் இறுதியில் வரும் பிறப்புத் தீட்டிற்காக மேலும் 3 நாள் காக்கத் தேவையில்லை.
    </li>
    <li>மரணத் தீட்டு ஜனனத் தீட்டைக் காட்டிலும் பலம்</li>
    <li>மரணத் தீட்டின்போது வந்த பிறப்புத் தீட்டு மரணத் தீட்டுடன் முடியும்.</li>
    <li>பெற்ற குழந்தை பத்துநாள் பிறப்புத் தீட்டிற்குள் இறந்தால் அதற்காகத் தனியாகத் தீட்டில்லை. பிறந்ததிலிருந்து 10 நாள் விலகும்.
      ஒரு வேளை 10ம் நாள் மரணமானால் மேலும் 2 நாள் அதிகரிக்கும். 10ம் நாள் இரவு ஆனால் 3 நாள்.</li>
    <li>பங்காளிகளுக்கு மேற்படி 3 நாள் தீட்டில்லை.</li>
    <li>
      <span style="color: crimson">அதிக்ராந்தாசெளசம் என்பது தீட்டுக்காலம் முடிந்தபின் தீட்டுப்பற்றி தெரிய வந்தவருக்கு விதிக்கப்படுவது.</span>
    </li>
    <li>
      <span style="color: crimson">பிறப்புத் தீட்டில் அதிக்ராந்தாசெளசம் இல்லை.</span>
    </li>
    <li>பத்து நாள் தீட்டை பத்தாம் நாளுக்குமேல் 3 மாதங்களுக்குள் கேட்டால் 3 நாள் தீட்டு.</li>
    <li>மூன்று மாதத்திற்கு மேல் 6 மாதத்திற்குள் கேட்டால் ஒன்றரை நாள்.</li>
    <li>6 மாதத்திற்கு மேல் ஒரு வருடத்திற்குள் ஒரு நாள்.</li>
    <li>அதன் பிறகு ஸ்னானம் மாத்திரம்.</li>
    <li>3 நாள் தீட்டை பத்து நாட்களுக்குள் கேட்டால் 3நாள் தீட்டு. பத்து நாட்களுக்குப் பிறகு ஸ்னானம் மாத்திரம்.</li>
    <li>1 நாள் தீட்டுக்கு அதிக்ராந்த ஆசெளசம் கிடையாது.</li>
    <li>மாதா பிதாக்களின் மரணத்தில் புத்திரர்களுக்கும், கணவனனின் மரணத்தில் பத்தினிக்கும் எப்போது கேட்டாலும் அதிலிருந்து 10
      நாள் தீட்டு உண்டு.</li>
  </ol>
</div>

` }} />
    </div>
  );
};

export default TheetuPage;
